import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { AddHiringDriveComponent } from '../add-hiring-drive/add-hiring-drive.component';
import { DriveEventService } from 'src/app/services/drive-event/drive-event.service';
import { DriveService } from 'src/app/services/drive/drive.service';
import { Router } from '@angular/router';
import { SearchService } from 'src/app/services/search/search.service';
import { UtilityService } from 'src/app/services/utility/utility.service';

@Component({
  selector: 'app-drive',
  templateUrl: './drive.component.html',
  styleUrls: ['./drive.component.scss']
})
export class DriveComponent implements OnInit {

  cards: any[];
  hiringDrive: any;
  toBeSearched: string;
  constructor(
    private driveEventService: DriveEventService,
    private drive: DriveEventService,
    private dialog: MatDialog,
    private driveService: DriveService,
    private router: Router,
    private searchService: SearchService,
    private utitlity: UtilityService
  ) { }

  ngOnInit() {
    this.getCards();
  }
  
  redirectToDriveContainer(item) {
    console.log(item);
    if(item.institutionId!=null && item.institutionId!=undefined && item.institutionId !== ''){
      if(item.type!=null && item.type!=undefined && item.type!=""){
        item.type=item.type.toUpperCase();
      }
      else{
        item.type= "COLLEGE";
      }
      this.router.navigate(['admin/drive-container/'+item.type+'/'+item.institutionId]);
    }
  }

  getCards() {
    this.utitlity.showSpinner();
    this.driveService.getDriveList().subscribe(
      response => {
        this.cards = (response as any).data;
        this.cards = this.cards.reverse();
        this.searchService.currentMessage.subscribe(
          response => {
            this.toBeSearched = response;
            this.utitlity.hideSpinner();
          })
        console.log('______________', this.cards);
      }
    );
 }

  openAddHiringDrive(): void {
    const dialogRef = this.dialog.open(AddHiringDriveComponent, {
      disableClose: true,
      panelClass: "dialog-style",
      //width: '50em',
      //height: '38em'
      //height: 'fit-content'
    });
    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed' , result);
      if(result)
       this.getCards();

    });
  }

}


